import $ from "../$.js";
import FizConfig from "../FizConfig.js";
import * as Html from "../util/Html.ts";
  
  // This is an implementation of the interface google.maps.OverlayView
  function MarkerConstructor(familyMap, address, place, locations){
    this.familyMap = familyMap;
    this.coordinates = new google.maps.LatLng(
        address.latitude,
        address.longitude
      );
    this.place = place;
    this.locations = locations;
    this.div = document.createElement('DIV');
  };

  // implements inheritance
  MarkerConstructor.prototype = new google.maps.OverlayView();
  Object.assign(MarkerConstructor.prototype,{
    onAdd(){
      import("./map_marker_html.mustache").then((mapMarkerTpl)=>{
        Html.setHtml($(this.div),mapMarkerTpl,{
          panicButtonActivated : $.grep(this.locations,function(m){return m.panicButtonActivated;}).length>0,
          locations: this.locations,
          place : this.place
        });
        
        this.div.style.position = 'absolute';
        this.div.style.transform ='translateZ(0px)';
        this.draw();

        this.getPanes().floatPane.appendChild(this.div);
      })
    },

    draw(){
      // Converts latitude and longitude coordinates to pixel.
      // adjusting the position of the overlap
      var
        position =
          this.getProjection().fromLatLngToDivPixel(this.coordinates);
      this.div.style.left = position.x + 'px';
      this.div.style.top = position.y + 'px';
    },

    onRemove(){
      try{
        this.div.parentNode.removeChild(this.div);
      }catch(e){}
      this.div = null;
    },

    bringToFront(bool) {
      if (bool){
        this.div.style ["z-index"] = "10";
      } else {
        this.div.style ["z-index"] = "";
      }
    }
  });


  var
    // Declare aliases
    markers = [],
    currentMap;

  /*
    Function: getDistanceInKm(latLng1, latLng2): number
    Get the distance in kilometers between two locations

    Parameters:
      latLng1 - object, google.maps.LatLng, coordinates of the first location
      latLng2 - object, google.maps.LatLng, coordinates of the second location

    Returns:
      number, the distance in kilometers between two geographic coordinates,
        computed over a sphere

    Note:
    In Google Maps API v3, the function to compute the distance between two
    coordinates is only included when loading the optional library "geometry".
    See computeDistanceBetween() in:
    https://code.google.com/intl/en
      /apis/maps/documentation/javascript/reference.html#spherical
  */
  function getDistanceInKm(latLng1, latLng2){
    var
      // 1 degree in radian, used for conversion from degrees to radians
      DEGREE_IN_RADIAN = Math.PI/180,
      // average earth radius in kilometers
      AVERAGE_EARTH_RADIUS_IN_KM = 6365,

      lat1InRad = latLng1.lat() * DEGREE_IN_RADIAN,
      lng1InRad = latLng1.lng() * DEGREE_IN_RADIAN,
      lat2InRad = latLng2.lat() * DEGREE_IN_RADIAN,
      lng2InRad = latLng2.lng() * DEGREE_IN_RADIAN;

    return AVERAGE_EARTH_RADIUS_IN_KM * Math.acos(
      Math.sin(lat1InRad) * Math.sin(lat2InRad) +
      Math.cos(lat1InRad) * Math.cos(lat2InRad) *
      Math.cos( lng2InRad - lng1InRad )
    );
  }
  function getSquareDim(latLng1, latLng2){
    var
      // 1 degree in radian, used for conversion from degrees to radians
      DEGREE_IN_RADIAN = Math.PI/180,
      // average earth radius in kilometers
      AVERAGE_EARTH_RADIUS_IN_KM = 6365,
      //the more we are far from equator, the more longitude diff causes less kilometers
      closestEquatorLatitude = Math.abs(latLng1.lat())<Math.abs(latLng2.lat())?latLng1.lat():latLng2.lat(),
      height = AVERAGE_EARTH_RADIUS_IN_KM * ((latLng1.lat()-latLng2.lat()) * DEGREE_IN_RADIAN),
      //handle that the earth is round
      lngDiffIndegree = Math.abs(latLng1.lng()-latLng2.lng())%180,
      width = Math.cos(closestEquatorLatitude * DEGREE_IN_RADIAN)*AVERAGE_EARTH_RADIUS_IN_KM * (lngDiffIndegree * DEGREE_IN_RADIAN);

    return {
      height:Math.abs(height),
      width:Math.abs(width)
    };
  }

  /*
    Function: getBarycenter(coordinatesList): LatLng
    Get the barycenter of a list of coordinates

    Parameter:
      coordinatesList - array of LatLng, a list of coordinates

    Returns:
      an instance of LatLng set to the barycenter of the list of coordinates,
      or null when the list of coordinates is empty
  */
  function getBarycenter(coordinatesList){
    var
      latitudeTotal = 0,
      longitudeTotal = 0,
      total = 0;

    coordinatesList.forEach(function (coordinates) {
      latitudeTotal += coordinates.lat ();
      longitudeTotal += coordinates.lng ();
      total++;
    });
    if (total === 0) {
      return null;
    }
    return new google.maps.LatLng (
      latitudeTotal / total,
      longitudeTotal / total
    );
  }

  /*
    Function: getCoordinatesList(locationsByAccountId): array
    Convert a list of check-in objects to a list of LatLng instances

    Parameter:
      locationsByAccountId - object, hash of accountId => object with last
        check-in of each family member

    Returns:
      an array of instances of LatLng corresponding to the location of each
      check-in in the given list

    Note:
    In case no check-in is included, an empty array is returned.
  */
  function getCoordinatesList(locationsByAccountId){
    var list = [];
    $.each (locationsByAccountId, function (accountId,location) {
      if(location.address){
        list.push(
            new google.maps.LatLng (
              location.address.latitude,
              location.address.longitude
            )
          );  
      }
      
    });
    return list;
  }

  /*
    Function: getCenterArea(collectionOfLatLng): LatLngBounds
    Compute an area for the display of the collection

    Since the family is initially displayed, this is the default view when the
    Map page is loaded, before a family member is selected.

    When at least one check-in is available, the barycenter of the known family
    family member positions is computed. The location of the family member
    closest to the barycenter is used as center for the family area.

    The family area is then extended to include the second closest member,
    however far, and each family member within a radius of 50 kilometers of the
    first family member.

    Parameter:
      locationsByAccountId - object, hash of accountId => object with last
        check-in of each family member

    Returns:
      null when there is no family member position checked in yet,
      otherwise an instance of LatLngBound for the computed family area
  */
  function getCenterArea(locationsByAccountId){
    var
      // maximum radius from center, in kilometers
      MAXIMUM_RADIUS_IN_KM = 50,

      coordinatesList,
      totalCheckins,
      barycenter,
      center,
      coordinates,
      familyArea,
      i;

    coordinatesList = getCoordinatesList(locationsByAccountId);
    totalCheckins = coordinatesList.length;
    if (totalCheckins === 0){
      return null;
    }

    barycenter = getBarycenter(coordinatesList);

    // sort by distance from the barycenter
    coordinatesList.sort(function(a,b){
      return (
        getDistanceInKm(a,barycenter) -
        getDistanceInKm(b,barycenter)
      );
    });

    // center family area on the family member closest to the barycenter
    center = coordinatesList[0];
    familyArea = new google.maps.LatLngBounds (center,center);

    if (totalCheckins === 1){
      return familyArea;
    }

    // enlarge family area to the second family member
    familyArea.extend(coordinatesList[1]);

    // enlarge family area to other family members closer than 50km
    for (i=2; i<totalCheckins; i++){
      coordinates = coordinatesList[i];
      if ( getDistanceInKm(coordinates,center) < MAXIMUM_RADIUS_IN_KM ){
        familyArea.extend(coordinates);
      } else {
        return familyArea;
      }
    }
    return familyArea;
  }

  /*
    Function: getZoom(familyArea): integer
    Get the zoom level for the selected family area

    Parameter:
      familyArea - object, instance of LatLngBounds for the family area

    Returns:
      integer, a suitable zoom level
  */
  function getZoomFor(familyArea,node){
    var
      dim = getSquareDim(
        familyArea.getNorthEast(),
        familyArea.getSouthWest()
      ),
      //si mon noeud est plus grand je peut zoomer plus
      zoomWidth = 6.5+ Math.log($(node).width()/dim.width) / Math.log(2),
      zoomHeight = 6.5+ Math.log($(node).height()/dim.height) / Math.log(2)
      ;
//    console.log(zoomWidth,$(node).width(),dim.width)
//    console.log(zoomHeight,$(node).height(),dim.height)
    return Math.max(1,Math.min(16,Math.floor(Math.min(zoomWidth,zoomHeight))));
    
  }

  /*
    Function: addFamilyPlacesMarkers(familyMap,googleMap,locationsByAccountId)
    Create the markers for family places and add them on the Family Map

    Parameters:
      familyMap - object, instance of FamilyMap, the Family Map
      googleMap - object, instance of google.maps.Map, the Google Map
      locationsByAccountId - object, map of accountId => location,
        the last check-in of each family member
  */
  function addFamilyPlacesMarkers(familyMap,googleMap,locationsByAccountId,places){
    //clear markers
    markers = [];
    places.forEach((place)=>{
      var
        membersLocation = [],
        marker;
      //onc cherche les memebre qui sont dans la place
      $.each(locationsByAccountId,function(i,location){
        if(location.placeId===place.placeId){
          membersLocation.push(location);
        }
      });
      marker = new MarkerConstructor(familyMap,place.address,place,membersLocation);
      marker.setMap (googleMap);
      markers.push (marker);
    });
    
    //handle all accounts on temporary places
    $.each(locationsByAccountId,function(i,location){
      var marker;
      if(location.place){
        //only for tempory place else it is handl previously by place displaying
        if(location.place.isTemporary){
          marker = new MarkerConstructor(familyMap,location.place.address,null,[location.author()]);
          marker.setMap (googleMap);
          markers.push (marker);
        }
      //for people not on place
      }else{
        marker = new MarkerConstructor(familyMap,location.address,null,[location.author()]);
        marker.setMap (googleMap);
        markers.push (marker);
      }
    });
    
  }

  /*
    Constructor: FamilyMap(node,locationsByAccountId,withoutMarkers): FamilyMap
    Create a new instance of FamilyMap with last check-in of each family member

    Parameters:
      node - DOM element, parent node for the map
      locationsByAccountId - object, hash of accountId => object with last
        check-in of each family member
      withoutMarkers - boolean, whether the map
        shall be displayed empty, without markers for check-ins.
        This option is used for geo-location experiment, and may be removed
        in a future version of this API.

    Returns:
      FamilyMap, the custom map with family places and family members
  */
  function FamilyMap(node, locationsByAccountId, places, withoutMarkers){
    var
      // instance of google.maps.LatLngBounds,
      // or null when there are no check-ins yet
      familyArea = getCenterArea(locationsByAccountId)||getCenterArea(places),
      defaultCenter = new google.maps.LatLng(FizConfig.defaultLocation.latitude,FizConfig.defaultLocation.longitude),
      // instance of google.maps.Map
      googleMap,
      wallIds,
      pathCache,
      currentCircle;
    
    
    googleMap = new google.maps.Map (node, {
      zoom: familyArea==null?FizConfig.defaultLocation.zoom:getZoomFor(familyArea,node),
      minZoom: 3,
      center: familyArea==null?defaultCenter:familyArea.getCenter(),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      zoomControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
        style: google.maps.ZoomControlStyle.LARGE
      },
      scaleControl: true,
      draggable: true,
      disableDefaultUI: true,
      disableDoubleClickZoom: true,
    });
    this.addZoom = (delta)=>{
      googleMap.setZoom(googleMap.getZoom()+delta);
    }
    //for hiding restaurant and other business stuffs
    //googleMap.setOptions({styles:[{featureType: "poi",stylers: [{ visibility: "off" }]}]});
    currentMap = googleMap;
    function refresh(positionById,places){
      //start by removing accuracy circle
      if(currentCircle){
        currentCircle.setMap(null);
        currentCircle = null;
      }
      
      locationsByAccountId = {};
      wallIds = [];
      $.each(positionById,function(id,position){
        if(position.wallMessageId){
          wallIds.push(position.wallMessageId);
        }
        if(position.address){
          locationsByAccountId[id]=position;
        }
      });
      if (!withoutMarkers) {
        //clean previous markers
        markers.forEach(function(marker){
          marker.setMap(null);
        });
        //recrete them
        addFamilyPlacesMarkers(this,googleMap,locationsByAccountId,places);
      }
    }
    refresh(locationsByAccountId,places);
    /*
      Function: centerAddress(address)
      Center the map on given address

      Parameter:
        address - object with following properties:
          latitude - number, the latitude of the expected center
          longitude - number, the longitude of the expected center
    */
    function centerAddress(address,showRadius){
      var latlng = (address instanceof google.maps.LatLng)?address:new google.maps.LatLng(address.latitude,address.longitude);
      googleMap.panTo(latlng);
      
      if(currentCircle){
        currentCircle.setCenter(latlng);
        currentCircle.setRadius(address.radius);
        currentCircle.setVisible(showRadius);
        
      }else{
        currentCircle = new google.maps.Circle({
          map: googleMap,
          strokeColor: '#2376AC',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#2376AC',
          fillOpacity: 0.35,
          center: latlng,
          radius: address.radius,
          visible:showRadius
        });  
      }
      
    }

    /*
      Function: centerPlace(placeId)
      Center the map on the place with given id

      In addition, an overlay is displayed with the details of the place.

      Parameter:
        placeId - string, the identifier of the place to center

      Note:
      Nothing happens in case the place is not found
    */
    function centerPlace (place) {
      var
        marker,
        i;
      
      for (i = 0; i < markers.length; i++) {
        marker = markers [i];
        if ( marker.place && marker.place.placeId === place.placeId ) {
          marker.bringToFront (true);
        }
      }

      if (!place || !place.address){
        return;
      }
      centerAddress(place.address,false);
    }

    function triggerResize () {
      if(googleMap){
        var
          map_zoom = googleMap.getZoom (),
          map_center = googleMap.getCenter ();
    
        google.maps.event.trigger (googleMap, 'resize');
        googleMap.setZoom (map_zoom);
        googleMap.setCenter (map_center);
      }
    }

    /*
      Function: centerFamilyMember(selected)
      Center the map on the given family member

      In addition, an overlay is displayed with the details of the family
      member and the place.

      Parameter:
        selected - string, the account identifier of the member to center,
          or "all" to center on the whole family (reset to default view)

      Note:
      Nothing happens in case the member has no known location.
    */
    function centerFamilyMember (location) {
      if(googleMap===null){
        setTimeout(function(){centerFamilyMember(location);},1000);
        return;
      }
      if (!location || !location.address){
        var centerArea = getCenterArea(locationsByAccountId);
        if(centerArea){
          centerAddress(centerArea.getCenter(),false);
          var newzoom = getZoomFor(centerArea,node);
          if(googleMap.getZoom()>newzoom){
            googleMap.setZoom(newzoom);
          }
        }
      }else{
        centerAddress (location.address,location.placeId==null);
        for (var i = 0; i < markers.length; i++) {
          var marker = markers [i];
          if ( marker.locations) {
            marker.locations.forEach(function(profile){
              if(profile.accountId===location.accountId){
                marker.bringToFront (true);
              }
            });
          }
        }
      }
    }

    /*
      Function: buildPath(locations)
      Display a path

      Parameter:
        locations - ordonnated list of locations constituting the path
    */
    function buildPath(locations){
      var
        markers = [],
        latLngs = [],
        circles = [],
        i,
        location,
        polyline;
      pathCache = {};
      for(i =0; i<locations.length; i++){
        location = locations[i];
        latLngs[i] = new google.maps.LatLng(
          location.address.latitude,
          location.address.longitude
        );
        markers[i] = new google.maps.Marker({
          map: googleMap,
          position: latLngs[i],
          title: location.time
        });
        circles[i] = new google.maps.Circle({
          map: googleMap,
          center: latLngs[i],
          radius: location.address.radius,
          visible:false,
          fillColor: '#000066'
        });
        pathCache [location.time] = {
          marker:markers [i],
          latLng:latLngs [i],
          circle:circles [i]
        };
      }
      polyline = new google.maps.Polyline({map: googleMap,path:latLngs});
    }

    /*
      Function: showPathPoint(dates)
      highlight the corresponding point of the path

      Parameter:
        date - date of the point

     */
    function showPathPoint(time){
      if(currentCircle) {
        currentCircle.setVisible(false);
      }
      currentCircle = pathCache[time].circle;
      currentCircle.setVisible(true);
      googleMap.panTo(pathCache[time].latLng);
    }

    /*
      Function: destroy()
      Destroy the map and associated resources

      Notes:
        This method must be called to avoid an "Invalid argument" error in IE8
        which occurs within Google code (main.js) when the container of the
        page which contains the map is removed from the DOM to be replaced
        with the container of a new page.

        According to the Google Maps team [1], the Google Maps API has not been
        designed to create and destroy instances of maps. The same instance
        should be reused instead, to avoid memory leaks.

        This destroy() method could be modified to keep the reference to
        the map and move the associated DOM object to a hidden part of the
        page to make it available for reuse when a new map is created.

        Reference:
        [1] What is the Proper Way to Destroy a Map Instance?
        http://stackoverflow.com/a/10660672/207968
    */
    function destroy(){
      wallIds = null;
      pathCache = null;
      currentCircle = null;
      // There is no method available to destroy an instance of map.
      // This is the closest we can get according to [2].
      //
      // Reference:
      // [2] GUnload() a single Google Map
      // http://stackoverflow.com/a/1943425/207968
      if(googleMap){
        googleMap.controls.forEach(function(control){
          if (control && control.clear){
            control.clear();
          }
        });
        google.maps.event.clearInstanceListeners(googleMap);
      }
      googleMap = null;
    }
    
    // Public API
    this.centerAddress = centerAddress;
    this.centerPlace = centerPlace;
    this.centerFamilyMember = centerFamilyMember;
    this.showPathPoint = showPathPoint;
    this.buildPath = buildPath;
    this.triggerResize = triggerResize;
    this.destroy = destroy;
    this.refresh = refresh;
  }

  /*
    Function: createMap(locationByAccountId,withoutMarkers): object
    Create a map to display the locations of family members and family places

    The map displays the location of every family place, and the last
    known position of every family member, given in the locations argument.

    Parameters:
      locationByAccountId - object, hash with the last check-in of each
        family member by accountId
      withoutMarkers - optional, boolean, defaults to false, whether the map
        shall be displayed empty, without markers for check-ins.
        This option is used for geo-location experiment, and may be removed
        in a future version of this API.

    Returns:
      object, an instance of the FamilyMap for family members and places
  */
  function createMap(locationByAccountId,places,withoutMarkers){
    return new FamilyMap(
      document.getElementById("map-familyMap"),
      locationByAccountId,
      places,
      withoutMarkers
    );
  }
  
  
function getCenter(){
  try{
    return currentMap.getCenter();
  }catch(e){
    return null;
  }
}  
function getZoom(){
  try{
    return currentMap.getZoom();
  }catch(e){
    return 14;
  }
}
export {createMap,getCenter,getZoom}